import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgUsersIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    {...props}
    width={24}
    height={24}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
  >
    <path
      d="M16.604 11.048a5.67 5.67 0 0 0 .75-3.44c-.178-1.784-1.174-3.361-2.802-4.44l-1.105 1.666c1.119.742 1.8 1.799 1.918 2.974a3.694 3.694 0 0 1-1.072 2.986L13.1 11.986l1.618.475c4.232 1.24 4.28 5.496 4.28 5.539h2c0-1.789-.955-5.285-4.395-6.952Z"
      fill="currentColor"
    />
    <path
      d="M9.5 12c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4Zm0-6c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2Zm1.5 7H8c-3.309 0-6 2.691-6 6v1h2v-1c0-2.206 1.794-4 4-4h3c2.206 0 4 1.794 4 4v1h2v-1c0-3.309-2.691-6-6-6Z"
      fill="currentColor"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgUsersIcon);
export default ForwardRef;
